import React from 'react';
import { MessageResponse } from '@api/ringil-api.v2';
import COInlineMessage from '@components/ringil3/COInlineMessage/COInlineMessage';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { formatBEValidationMessage } from '@hooks/useBEValidation/formatBEValidationMessage';

interface ComponentProps {
  /** undefined = not checked yet, true = slot is free, false = backend refused the reservation */
  valid?: boolean;
  /** Validation messages returned by company/reservation/check; empty for an unknown/transport error */
  messages?: MessageResponse[];
}

/**
 * Result of the "check reservation" call. When the backend explains why the reservation is not
 * possible (VALIDATION messages, usually locized with params) we show those reasons; otherwise —
 * an unknown error, a transport failure — we fall back to the generic message.
 */
const ReservationCheckResult: React.FC<ComponentProps> = ({ valid, messages }) => {
  const { tr } = useTranslationLgs();

  if (valid == null) return null;

  if (valid) {
    return <COInlineMessage variant={'success'}>{tr(`CreateTimeslotSidebar.reservationPossible`, `Reservation is possible in this time and ramp`)}</COInlineMessage>;
  }

  return (
    <COInlineMessage variant={'error'}>
      {messages?.length > 0 ? (
        <div className={'flex flex-col gap-1'}>
          {messages.map((message, index) => (
            <div key={index}>{formatBEValidationMessage(message, tr)}</div>
          ))}
        </div>
      ) : (
        tr(`CreateTimeslotSidebar.reservationImpossible`, `Reservation is not possible in this time and ramp`)
      )}
    </COInlineMessage>
  );
};

export default ReservationCheckResult;
